import { ChevronLeftCircleIcon, ChevronRightCircleIcon } from 'lucide-react';
import { useState, useRef } from 'react';

export const LinkedAccounts = ({
  linkedAccounts,
  downPaymentSuccess,
  selectedAccountId,
  setSelectedAccountId,
  setSelectedBankAuthCode,
}) => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = direction === 'left' ? -294 : 294;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="w-[265px] md:w-[300px] mb-6">
      <div
        ref={scrollContainerRef}
        className="flex w-[265px] md:w-[300px] overflow-x-auto space-x-4 scrollbar-hide scroll-smooth snap-x snap-mandatory"
      >
        {linkedAccounts?.mandates?.map((account) => (
          <SingleLinkedAccount
            key={account.Id}
            account={account}
            selectedAccountId={selectedAccountId}
            onSelect={setSelectedAccountId}
            downPaymentSuccess={downPaymentSuccess}
            setSelectedBankAuthCode={setSelectedBankAuthCode}
          />
        ))}
      </div>
      {linkedAccounts?.mandates?.length > 1 && (
        <div className="flex justify-between mt-4">
          <button
            onClick={() => scroll('left')}
            disabled={!downPaymentSuccess}
            className={`p-2 rounded-full transition ${
              downPaymentSuccess
                ? 'bg-[#FFDE11] text-black hover:bg-[#e6c90f]'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            aria-label="Scroll left"
          >
            <ChevronLeftCircleIcon className="w-5 h-5" />
          </button>

          <button
            onClick={() => scroll('right')}
            disabled={!downPaymentSuccess}
            className={`p-2 rounded-full transition ${
              downPaymentSuccess
                ? 'bg-[#FFDE11] text-black hover:bg-[#e6c90f]'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            aria-label="Scroll right"
          >
            <ChevronRightCircleIcon className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

const SingleLinkedAccount = ({
  account,
  selectedAccountId,
  onSelect,
  downPaymentSuccess,
  setSelectedBankAuthCode,
}) => {
  const isSelected = selectedAccountId === account.Id;
  const selectedAuthCode = account?.bank_authorization_code;

  const handleSelect = () => {
    if (account) {
      onSelect(account.Id);
      setSelectedBankAuthCode(account?.authorization_code);
    }
  };

  return (
    <label
      className={`${downPaymentSuccess ? 'cursor-pointer' : 'cursor-not-allowed'} rounded-[10px] font-medium font-duplet text-sm p-4 flex justify-between items-center min-w-[260px] md:min-w-[294px] h-[110px] ${isSelected ? 'bg-[#FFDE11]' : 'border'}`}
    >
      <div className="flex flex-col">
        <p className="font-semibold text-xl">
          {(account?.account_name?.length > 19
            ? account.account_name.slice(0, 19) + '...'
            : account?.account_name) || 'Account Name'}
        </p>
        <p className="text-xs">{account?.bank_name}</p>
        <p className="text-xs flex items-center">
          <span>******</span>
          {account?.last4}
        </p>
      </div>
      <input
        type="radio"
        name="linked-account"
        checked={selectedAccountId === account.Id}
        onChange={handleSelect}
        className={`accent-black ${downPaymentSuccess ? 'cursor-pointer' : 'cursor-not-allowed'}`}
        disabled={!downPaymentSuccess}
      />
    </label>
  );
};
